module.exports = __webpack_public_path__ + "static/media/email1.ba170720.svg";